export const POPOVER_INLINE_SIZE_FALLBACK_PX = 400;
export const CTA_COLUMN_WIDTH_EXTRA_PX = 20;
export function getPopoverInlineSize(columnCallToAction, fallbackWidthPx) {
  return columnCallToAction.popoverInlineSize !== undefined ? columnCallToAction.popoverInlineSize : fallbackWidthPx;
}
export function getCtaMinimumColumnWidthPx(columnCallToAction) {
  return getPopoverInlineSize(columnCallToAction, POPOVER_INLINE_SIZE_FALLBACK_PX) + CTA_COLUMN_WIDTH_EXTRA_PX;
}